<nz-tree-select
[nzDropdownStyle]="{ 'max-height': '300px','touch-action': 'none' }"
[(ngModel)]="defaultValue"
[nzNodes]="nodes"
[nzDisabled]="nzDisabled"
[nzShowSearch]="nzShowSearch"
 
[nzCheckable]="nzCheckable"
[nzDefaultExpandAll]="nzDefaultExpandAll"
(ngModelChange)="onChange($event)"
 
nzPlaceHolder="请选择"
>
</nz-tree-select>
